<template>
  <!-- -->
  <div class="banner-show mini-component-show" :style="{'--component-height': `${data.height || '300'}px`}">
    <el-carousel :autoplay="true">
      <el-carousel-item v-for="(item, idx) in imageList" :key="idx">
        <div class="carousel-area">
          <alone-image :src="item.itemImage"/>
          <div class="table-text" :style="{'color': item.textColor, 'backgroundColor': item.textBackground, 'font-size': item.textSize, 'text-align': item.textAlign}">{{item.text}}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";

export default {
  props: {
    data: {default: () => {
        return {}
      }},
  },
  name: "",
  components: {
    AloneImage
  },
  data() {
    return {
      imageList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-show{
  :deep(.el-carousel){
    .el-carousel__container{
      height: var(--component-height);
    }
  }
  .carousel-area{
    min-height: 250px;
    position: relative;
    overflow: hidden;
    height: 100%;
    .table-text{
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 30px;
      padding: 0 30px;
      overflow: hidden;
      white-space: nowrap;
      box-sizing: border-box;
      font-size: 32px;
    }
  }
}
</style>